import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { JbpListFiltersDto } from '../models/jbp-list.dto';
import { Jbp } from '../models/jbp';
import { IListResponseData } from '../models/list-reponse-data';
import { JbpPriority } from '../models/jbp-priority';
import { JbpDto, JbpUpdateDto } from '../models/jbp.dto';
import { map, tap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { JointBusinessPlanPollDto } from '../models/jbp-poll.dto';

@Injectable({
  providedIn: 'root',
})
export class JbpService {
  constructor(private readonly http: HttpClient) {}

  getItems(dto: JbpListFiltersDto) {
    console.log(dto);
    return this.http.get<IListResponseData<Jbp[]>>(
      `${environment.api}/panel/joint-business/list`,
      {
        params: {
          ...(dto as any),
        },
      }
    );
  }

  getPlan(id: number) {
    return this.http
      .get<Jbp>(`${environment.api}/panel/joint-business/${id}/details`)
      .pipe(
        map((val) =>
          // val.status = 'period1';
          // val.status_comments[0] = {
          //   comment: 'sasa',
          //   status: 'started'
          // };
          // val.status_comments[1] = {
          //   comment: 'sasasasa',
          //   status: 'period1'
          // };
          // val.status_comments[2] = {
          //   comment: 'sasasasa',
          //   status: 'period2'
          // };
           val
        )
      );
  }

  getPriority() {
    return this.http.get<JbpPriority[]>(
      `${environment.api}/panel/joint-business/priority/dropdown`
    );
  }

  getStrategies(priorityId: number) {
    return this.http.get<JbpPriority[]>(
      `${environment.api}/panel/joint-business/priority/${priorityId}/strategies`
    );
  }

  getActions(priorityId: number) {
    return this.http.get<{ offline: JbpPriority[]; online: JbpPriority[] }>(
      `${environment.api}/panel/joint-business/strategy/${priorityId}/actions`
    );
  }

  create(dto: JbpDto) {
    return this.http.post<{ offline: JbpPriority[]; online: JbpPriority[] }>(
      `${environment.api}/panel/joint-business`,
      dto
    );
  }

  update(dto: JbpUpdateDto, id: number) {
    return this.http.post<{ offline: JbpPriority[]; online: JbpPriority[] }>(
      `${environment.api}/panel/joint-business/${id}`,
      dto
    );
  }

  comment(id: number, comment: string) {
    return this.http.post(
      `${environment.api}/panel/joint-business/${id}/update-comment`,
      {
        comment,
      }
    );
  }

  draft(id: number, draft: string) {
    return this.http.post(
      `${environment.api}/panel/joint-business/${id}/update-draft`,
      {
        comment: draft,
      }
    );
  }

  export(data: { filename: string; name: string }) {
    return this.http
      .get<any>(`${environment.api}/panel/joint-business/export/xlsx`, {
        // @ts-ignore
        responseType: 'blob',
      })
      .pipe(
        tap((res: any) => {
          const blobData: Blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blobData, `${data.filename}.xlsx`);
        })
      );
  }

  downloadPdf(id: number, clientName: string) {
    return this.http
      .get(`${environment.api}/panel/joint-business/${id}/download-plan`, {
        responseType: 'blob',
      })
      .pipe(
        tap((res: Blob) => {
          const blobData = new Blob([res], { type: 'application/pdf' });
          saveAs(blobData, `jbp.pdf`);
        })
      );
  }

  savePoll(id: number, pollDto: JointBusinessPlanPollDto) {
    return this.http.post(
      `${environment.api}/panel/joint-business/${id}/save-poll`,
      pollDto
    );
  }
}
